import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthModule } from '@app/auth/auth.module';
import { TruncateModule } from '@app/shared/pipes';
import {
  AlertComponent,
  AvatarComponent,
  BadgeComponent,
  ButtonComponent,
  IconComponent,
  ModalComponent,
  OverlayComponent,
  PatronModule,
  SpinnerComponent,
  ToastComponent,
  ToastService,
} from '@teorema/patron';
import { QuillModule } from 'ngx-quill';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PopoverModule } from 'primeng/popover';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { CartWidgetComponent } from '../cart-widget/cart-widget.component';
import { NotificationModule } from '../notification/notification.module';
import { SwitchThemeComponent } from '../switch-theme/switch-theme.component';
import { AiRunActivityComponent } from '../../../features/ai/components/run-activity/ai-run-activity.component';
import { LayoutV2Component } from './layout-v2.component';

@NgModule({
  declarations: [LayoutV2Component],
  imports: [
    CommonModule,
    AiRunActivityComponent,
    BadgeComponent,
    IconComponent,
    ButtonComponent,
    AvatarComponent,
    PopoverModule,
    RouterModule,
    ToastComponent,
    PatronModule,
    AlertComponent,
    ModalComponent,
    AuthModule,
    TruncateModule,
    OverlayComponent,
    StyleClassModule,
    ScrollPanelModule,
    NgScrollbarModule,
    SpinnerComponent,
    NotificationModule,
    QuillModule.forRoot(),
    SwitchThemeComponent,
    CartWidgetComponent,
    PanelMenuModule,
    TooltipModule,
  ],
  exports: [LayoutV2Component],
  providers: [ToastService],
})
export class LayoutV2Module {}
